// Shared ambience helper — subtle tone shifts per round kind.
// Returns className utilities; kept restrained, never loud.
export function roundAmbience(kind = "values") {
  switch (kind) {
    case "values":
      // calm / grounded — cooler navy, quiet hairline
      return {
        panelClass: "bg-[#080B14]",
        glowStyle: {
          background:
            "radial-gradient(ellipse 60% 50% at 50% 0%, rgba(107,76,219,0.06), transparent 70%)",
        },
        accent: "#A1ABC0",
        label: "Values",
      };
    case "communication":
      // responsive / dynamic — soft violet
      return {
        panelClass: "bg-[#0A0D17]",
        glowStyle: {
          background:
            "radial-gradient(ellipse 70% 60% at 20% 20%, rgba(107,76,219,0.12), transparent 65%)",
        },
        accent: "#B6A4F2",
        label: "Communication",
      };
    case "chemistry":
      // warmer tones — burgundy + gold
      return {
        panelClass: "bg-[#0B0910]",
        glowStyle: {
          background:
            "radial-gradient(ellipse 70% 60% at 80% 30%, rgba(185,58,80,0.12), transparent 65%), radial-gradient(ellipse 40% 40% at 20% 80%, rgba(212,175,55,0.08), transparent 70%)",
        },
        accent: "#F5A8B5",
        label: "Chemistry",
      };
    case "future":
      return {
        panelClass: "bg-[#080B14]",
        glowStyle: {
          background:
            "radial-gradient(ellipse 60% 50% at 50% 100%, rgba(74,163,106,0.1), transparent 70%)",
        },
        accent: "#8FD6A6",
        label: "Future",
      };
    case "effort":
      return {
        panelClass: "bg-[#080B14]",
        glowStyle: {
          background:
            "radial-gradient(ellipse 60% 50% at 80% 80%, rgba(212,175,55,0.08), transparent 70%)",
        },
        accent: "#F2DE94",
        label: "Effort",
      };
    case "final":
      // minimal, focused, quiet
      return {
        panelClass: "bg-[#05070D]",
        glowStyle: {
          background:
            "radial-gradient(ellipse 40% 30% at 50% 50%, rgba(212,175,55,0.05), transparent 80%)",
        },
        accent: "#F2DE94",
        label: "Final",
      };
    default:
      return {
        panelClass: "bg-[#080B14]",
        glowStyle: {},
        accent: "#D4AF37",
        label: "Round",
      };
  }
}
